import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const MobileSortButtonWrapper = styled.div`
  ${media.mediumUp`
    display:none
  `};
`;
